import fetchAPI from '../utils/fetchAPI';
import type { FormData } from '../apps/AdmarktRegistration/types';
import { getUtmParams } from '../utils/utmStorage';

export default function registerProUserService({ xsrfToken, data }: { xsrfToken: string; data: FormData }) {
  const utmParams = getUtmParams();
  return fetchAPI({
    method: 'POST',
    url: `/smb-profile/api/pro/register`,
    payload: utmParams ? { ...data, utmParams } : data,
    xsrfToken,
  });
}
